<template>
  <v-dialog v-model="dialog" width="800" :persistent="true">
    <v-card>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>{{ modalTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark small @click="close">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text>
        <v-form>
          <v-layout row wrap>
            <v-flex xs12>
              <v-autocomplete
                  v-model="selectedLikeable"
                  :items="likeables"
                  :search-input.sync="likeableSearch"
                  :clearable="true"
                  :loading="likeablesLoading"
                  :placeholder="`app.likeable.search_product` | trans"
                  :hint="hint"
                  :no-data-text="noDataText"
                  :hide-selected="true"
                  :deletable-chips="true"
                  @change="productSelected()"
                  item-text="name"
                  item-value="likeable_id"
                  multiple
                  hide-details
                  return-object
                  no-filter
                  chips
              >
                <template v-slot:item="data">
                  <template>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.name" :title="data.item.name"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-flex>
          </v-layout>
        </v-form>

      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" flat @click="close">
          {{ 'app.close' | trans }}
        </v-btn>
        <v-btn color="primary" @click="save" :loading="loading">
          {{ 'app.save' | trans }}
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import {TYPES} from "../../../helpers/likeables";
import {trans} from "../../../app";
import {mapActions, mapGetters} from "vuex";

export default {
  data: function () {
    return {
      dialog: false,
      loading: false,
      mode: 'products',
      type: 'like',
      likeables: [],
      likeableSearch: null,
      likeablesLoading: false,
      selectedLikeable: [],
      hint: undefined,
      currentTimeout: null,
    };
  },
  methods: {
    open(mode, type) {
      this.dialog = true;
      this.mode = mode;
      this.type = type;
    },
    close() {
      this.dialog = false;
      this.selectedLikeable = [];
      this.likeables = [];
    },
    async save() {
      if (this.selectedLikeable.length === 0) {
        this.close();
        return;
      }
      this.loading = true;
      try {
        await axios.post(`/v2/patients/${this.patient.id}/store-autocomplete-likeables`, {
          type: this.type,
          approach: this.mode,
          likeables_ids: this.selectedLikeable.map(selectedLikeable => selectedLikeable.likeable_id),
        });
      } catch (e) {
        this.$toast.error(trans('app.error_occurred'));
      }

      this.fetchLikeables({patientId: this.patient.id});
      this.loading = false;
      this.close();
      this.$toast.success(trans('app.saved'));
    },
    productSelected() {
      if (this.selectedProduct) {
        this.selectedLikeable.push({
          likeable_id: this.selectedProduct.likeable_id,
          name: this.selectedProduct.name,
        })
        this.likeables = [];
        this.likeableSearch = null;
      }
    },
    clearTimeoutIfExists() {
      if (this.currentTimeout !== null) {
        clearTimeout(this.currentTimeout);
        this.currentTimeout = null;
      }
    },
    ...mapActions(['fetchLikeables']),
  },
  computed: {
    ...mapGetters(['patient']),
    noDataText() {
      if (!this.likeableSearch) {
        return trans('app.type_at_least_n_characters', {count: 3});
      }
      return this.likeableSearch.length > 0 && this.likeableSearch.length < 3
          ? trans('app.type_at_least_n_characters', {count: 3})
          : trans('app.no_data_to_display_or_product_already_added');
    },
    modalTitle() {
      const key = this.type === TYPES.PRODUCT_TYPE ? 'app.add_product' : 'app.add_product_category';

      return trans(key);
    },
  },
  watch: {
    async likeableSearch(val) {
      this.clearTimeoutIfExists();
      if (!val) {
        this.hint = undefined;

        return;
      }
      this.hint = val.length > 0 && val.length < 3 ? trans('app.type_at_least_n_characters', {count: 3}) : undefined;
      if (val.length < 3) {
        return;
      }
      this.likeablesLoading = true;
      this.currentTimeout = setTimeout(async () => {
        const body = {
          q: val,
          type: this.type,
          patient_id: this.patient.id,
        };
        const {data} = await axios.get(`/v2/likeables-search`, {params: body});
        this.likeables = [...data.data, ...this.selectedLikeable];
        this.likeablesLoading = false;
        this.currentTimeout = null;
      }, 500);
    },
  },
}
</script>

<style scoped>

</style>
